import { thirdAuthLink, thirdData } from '@/apis/login'
import store from '@/store'
import { UPDATE_TRIPARTITEUSERINFO } from '@/store/modules/tripartite'

/**
 * 第三授权平台方枚举
 */
export enum Plat {

  /** facebook */
  FB = 'facebook',
  /** google  */
  GG = 'google',
  /** Line */
  LE = 'line',
  /** apple */
  AP = 'apple',
  /** yahoo */
  YH = 'yahoo',
  /** tiktok */
  TK = 'tiktok',
}

// 平台值
export type platType = `${Plat}`

export interface UserInfo {
  thirdCustomerEmail: string;
  thirdCustomerId: string;
  thirdCustomerName: string;
  thirdCustomerPhone?: string;
  thirdPlatform: platType;
}

// 授权响应
export interface AuthResponse<U extends UserInfo = UserInfo> {
  code: string;
  plat: platType;
  success: boolean;
  errMsg?: string;
  userInfo?: U;
}

/** 储存回调平台字段 */
export const AUTH_PLAT = '__auth_plat__'
export const APPLE_USER = '__apple_user__'

/**
 * 获取hash后的参数
 * @param name
 * @returns string
 */
export const getHashString = (name: string, url = window.location.hash) => {
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  if (url.indexOf('#') < 0) {
    return null
  }
  const r = url.split('#')[1].match(reg)
  if (r != null) return decodeURIComponent(r[2])
  return null
}

export const getQueryParams = (url: string = window.location.search) => {
  const params = new URLSearchParams(url)
  const queryParams = {} as Record<string, string>
  for (const [key, value] of params) {
    queryParams[key] = decodeURIComponent(value)
  }
  return queryParams
}
/** 获取当前平台信息 */
export const getPlat = () => localStorage.getItem(AUTH_PLAT) as platType

type Auth2Params = {
  /** 重定向url */
  redirect?: string,
  /** 授权平台信息 */
  plat: platType,
  h5?: boolean
}
// 授权是否进行中
let openWinTimer: any = null
let storageTrue = true

/** 跳转授权链接 */
export const openAuth2 = async ({ plat, h5 = false }: Auth2Params, callBack: ((response: AuthResponse) => void)): Promise<void> => {
  if (openWinTimer) return
  openWinTimer = true
  const redirect = location.origin + '/auth'
  let win: any = null
  if (!sessionStorage.getItem('needGotoLoginH5')) {
    win = window.open('', 'newwindow', 'height=700, width=950, top=100, left=100, toolbar=no, menubar=no, scrollbars=no, resizable=no,location=no, status=no') as Window
  }
  localStorage.setItem(AUTH_PLAT, plat)
  // 防止重复授权
  openWinTimer = setInterval(() => {
    if (win && win.closed) {
      openWinTimer = false
      clearInterval(openWinTimer)
    }
  }, 500)
  const res = await thirdAuthLink({ thirdPlatform: plat, redirectUrl: redirect })
  if (res.success) {
    if (sessionStorage.getItem('needGotoLoginH5')) {
      location.href = res.data
    } else {
      win.location = res.data
    }
    const changeStorage = async (e: any) => {
      // 到AUTH页面的URL 给登录之后回跳使用
      if (window.location.href.includes('h5/promotion/goodsDetail')) {
        localStorage.setItem('TO_AUTH_PAGE_URL', window.location.href)
      }
      console.log(e, 'storage')
      if (e.key === APPLE_USER) {
        const appleUser = e.newValue
        console.log(appleUser, 'appleUser')
        if (appleUser) {
          const appleData = JSON.parse(appleUser)
          const plat = getPlat()
          let submitD = { authCode: appleData.code, thirdPlatform: plat, redirectUrl: redirect, state: appleData.state } as any
          if (plat === Plat.AP && appleUser) {
            submitD = { ...submitD, ...appleData }
          }
          if (appleData.code && plat && appleData.state && storageTrue) {
            localStorage.removeItem(APPLE_USER)
            storageTrue = false
            const res = await thirdData(submitD).finally(() => {
              storageTrue = true
            })

            if (res.success) {
              // 无论是否绑定，用户都已授权，应存入store
              store.commit(UPDATE_TRIPARTITEUSERINFO, { ...res.data, thirdPlatform: plat })
              callBack && callBack({ code: appleData.code, plat, success: true, userInfo: { ...res.data } })
            } else {
              callBack && callBack({ code: appleData.code, plat, success: false })
            }

            // 移除localStorage监听
            window.removeEventListener('storage', changeStorage)
          }
          win.close()
        }
      }
    }
    window.addEventListener('storage', changeStorage)
  } else {
    clearInterval(openWinTimer)
    win.close()
  }
}

export const continueLogin = async (callBack: any) => {
  const appleData = JSON.parse(localStorage.getItem(APPLE_USER)!)
  const plat = getPlat()
  const redirect = location.origin + '/auth'
  let submitD = { authCode: appleData.code, thirdPlatform: plat, state: appleData.state, redirectUrl: redirect } as any
  if (plat === Plat.AP && appleData) {
    submitD = { ...submitD, ...appleData }
  }
  if (appleData.code && plat && appleData.state) {
    const res = await thirdData(submitD)
    if (res.success) {
      // 无论是否绑定，用户都已授权，应存入store
      store.commit(UPDATE_TRIPARTITEUSERINFO, { ...res.data, thirdPlatform: plat })
      callBack && callBack({ code: appleData.code, plat, success: true, userInfo: { ...res.data } })
    } else {
      callBack && callBack({ code: appleData.code, plat, success: false })
    }
    localStorage.removeItem(APPLE_USER)
  }
}

/** 处理不通平台的错误信息 */
const errorDeal = (plat: platType) => {
  const errMsg = ''
  switch (plat) {
    case Plat.GG:

      break

    default:
      break
  }
  return errMsg
}

/**
 * 获取授权信息code
 * @returns
 */
export const getAuthCode = () => {
  const plat = getPlat()
  const errMsg = errorDeal(plat)
  // eslint-disable-next-line camelcase
  const { code, state, email, id_token, username } = getQueryParams()
  return { code, errMsg, state, email, idTokend: id_token, username }
}
